<template>
  <div class="homepage-layout">
    <Header v-bind="$props" />
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['wideHeader', 'heroDark']
}
</script>



// WEBPACK FOOTER //
// src/components/layout/HomepageLayout.vue